import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

const useRunError = (isValid: any, errors: any, submitCount: number) => {
  const runError = useCallback(() => {
    if (!isValid && Object.keys(errors).length > 0 && submitCount > 0) {
      toast.error("Please fill required fields");
    } else {
      return null;
    }
  }, [isValid, errors, submitCount]);

  return runError;
};

export default useRunError;
